import React, { useState } from "react";
import UsersList from "./UsersList";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import OperationPanel from "../../../components/Common/OperationPanel";
import CommonModal from "../../../components/Common/CommonModal";
import CreateUser from "../CreateUser/index";
import AssignManager from "./AssignManager";
import UserTree from "./UserTree";
import UserPermissionOverrideModal from "../../../components/Permissions/UserPermissionOverrideModal";
import usePermission from "../../../Hooks/usePermission";
import LoginModal from "../../../components/Team/Users/LoginModal";

function Index() {
  const { hasPermission } = usePermission();
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [modal, setModal] = useState(false);
  const [mode, setMode] = useState("create");
  const [selectedUser, setSelectedUser] = useState(null);
  const [permissionModal,setPermissionModal]=useState(false);
  const [loginModal,setLoginModal]=useState(false);
  const [refresh, setRefresh] = useState(false);
  return (
    <div className="page-content">
      <Breadcrumbs title="Team" breadcrumbItem="Users List" />

      <OperationPanel
        search={search}
        setSearch={setSearch}
        addLabel="Add User"
        showAddButton={hasPermission("Create Users")}
        onAdd={() => { setMode("create"); setSelectedUser(null); setModal(true); }}
        filters={[
          // {
          //   value: role,
          //   onChange: setRole,
          //   placeholder: "Filter by Role",
          //   options: [
          //     // { label: "Admin", value: "admin" },
          //     { label: "Employee", value: "employee" },
          //     // { label: "Super Admin", value: "super_admin" },
          //   ],
          // },
        ]}
      />
      <UsersList
        search={search}
        setLoginModal={setLoginModal}
        hasPermission={hasPermission}
        role={role}
        setMode={setMode}
        setSelectedUser={setSelectedUser}
        setModal={setModal}
        setPermissionModal={setPermissionModal}
        refresh={refresh}
      />
      <UserPermissionOverrideModal
        isOpen={permissionModal}
        toggle={()=>setPermissionModal(false)}
        selectedUser={selectedUser}
      />
      <LoginModal
          isOpen={loginModal}
          toggle={() => setLoginModal(false)}
          selectedUser={selectedUser}
          onSuccess={()=>{
              setRefresh(prev=>!prev);
              setLoginModal(false);
          }}
      />
      <CommonModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title={
          mode === "edit"
            ? "Edit User"
            : mode === "assignManager"
            ? "Assign Reporting Manager"
            : mode === "tree"
            ? "User Hierarchy"
            : "Create User"
        }
      >
        {mode === "assignManager" ? (
          <AssignManager
            selectedUser={selectedUser}
            onSuccess={() => {
              setModal(false);
              setRefresh((prev) => !prev);
            }}
          />
        ) : mode === "tree" ? (
          <UserTree selectedUser={selectedUser} />
        ) : (
          <CreateUser
            isModal
            mode={mode}
            selectedUser={selectedUser}
            onSuccess={() => {
              setModal(false);
              setRefresh((prev) => !prev);
            }}
          />
        )}
      </CommonModal>
    </div>
  );
}

export default Index;